/** Sort helpers for Admin Task > EdCity School ID Mapping.

The list is capped at 500 rows, so the composer re-sorts locally on a header
click (instant) and also sends `order_by`/`order` on the next list request so
the server window matches the column the operator clicked.
*/

export const DEFAULT_EDCITY_SCRN_SORT_BY = 'created_at';
export const DEFAULT_EDCITY_SCRN_SORT_DIR = 'DESC';

export const EDCITY_SCRN_SORT_COLUMNS = [
  'school_code',
  'note',
  'school_id',
  'school_name',
  'school_name_eng',
  'created_at',
];

export function nextEdcityScrnSort(sortBy, sortDir, column) {
  if (sortBy === column) {
    return {
      sortBy: column,
      sortDir: String(sortDir).toUpperCase() === 'ASC' ? 'DESC' : 'ASC',
    };
  }
  return {
    sortBy: column,
    sortDir: column === 'created_at' ? 'DESC' : 'ASC',
  };
}

function mappedSchoolId(row) {
  const n = parseInt(row && row.school_id, 10);
  return Number.isFinite(n) && n > 0 ? n : null;
}

function createdAtMillis(row) {
  const raw = row && row.created_at;
  if (!raw) {
    return null;
  }
  const t = Date.parse(String(raw).replace(' ', 'T'));
  return Number.isNaN(t) ? null : t;
}

function sortValue(row, column) {
  switch (column) {
    case 'school_code':
      return String((row && row.school_code) || '');
    case 'note':
      return String((row && row.note) || '');
    case 'school_id':
      return mappedSchoolId(row);
    case 'school_name':
      return String((row && row.school_name) || '');
    case 'school_name_eng':
      return String((row && row.school_name_eng) || '');
    case 'created_at':
      return createdAtMillis(row);
    default:
      return '';
  }
}

function compareValues(va, vb, dir) {
  if (va == null && vb == null) {
    return 0;
  }
  // Unmapped / missing values sit at the end in both directions.
  if (va == null) {
    return 1;
  }
  if (vb == null) {
    return -1;
  }
  if (typeof va === 'number' && typeof vb === 'number') {
    return (va - vb) * dir;
  }
  return String(va).localeCompare(String(vb), 'zh-Hant', {
    numeric: true,
    sensitivity: 'base',
  }) * dir;
}

export function sortEdcityScrnRows(rows, sortBy, sortDir) {
  const list = Array.isArray(rows) ? rows : [];
  const dir = String(sortDir).toUpperCase() === 'ASC' ? 1 : -1;
  const column = EDCITY_SCRN_SORT_COLUMNS.includes(sortBy)
    ? sortBy
    : DEFAULT_EDCITY_SCRN_SORT_BY;
  return [...list].sort((a, b) => compareValues(sortValue(a, column), sortValue(b, column), dir));
}
